import React from "react";
import {Button, Input, Modal, Form} from "antd";
import {ModalProps} from "antd/lib/modal";
import {FormInstance} from "antd/lib/form";
import Select from "../../../../components/Select";

interface ModifyModalProps extends ModalProps {
    form: FormInstance
}

export default function DealerGroupEditModal(props: ModifyModalProps) {

    const {form, ...otherProps} = props

    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'id'} noStyle>
                    <Input style={{display: 'none'}}/>
                </Form.Item>
                <Form.Item label={'集团'} name={'group'} required={true}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'描述'} name={'desc'} required={true}>
                    <Input/>
                </Form.Item>
                <Form.Item name={'saleMan'} label={'销售人员'} rules={[{required: true, message: '请选择销售人员'}]}>
                    <Select url={'/user/dict'} getData={data => data.data} textField={'nickName'} valueField={'id'}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}
